import { render, staticRenderFns } from "./AditivoForm.vue?vue&type=template&id=fd9bb188&"
import script from "./AditivoForm.vue?vue&type=script&lang=js&"
export * from "./AditivoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports